import React, { useState, useEffect } from "react";
import { CardContainer } from "./styles";
import moment from "moment";
import parse, { domToReact } from "html-react-parser";
import { Avatar } from "../../components/Avatar";
import { useHistory } from "react-router-dom";
import { resolveProfileIcon } from "../../utils/profileIcon";
import Icon from "../Icon";

const svgContext = require.context("../../assets/", true, /\.png|\.svg$/);

// Resolve a profile (letter/number) or legacy asset icon to an <img> src.
const resolveIconSrc = icon => {
  const key = `./${icon}`;
  if (svgContext.keys().includes(key)) return svgContext(key);
  return resolveProfileIcon(icon);
};

// legacy icon mapping for deleted icons
const LEGACY_ICONS = {
  "mic-logo-center.png": "v2-icons/blue_dot_icon.svg",
  "editor-admin-open.svg": "v2-icons/editor_admin.svg",
  "full-cart.svg": "v2-icons/receipt.svg",
  "search.svg": "v2-icons/search.svg",
  "browse.svg": "v2-icons/album.svg",
  "remove-track.svg": "v2-icons/circle-minus.svg",
  "warning.svg": "v2-icons/triangle-alert.svg"
};

const NotificationCard = ({ notification, onClick, onClose }) => {
  const [time, setTime] = useState(null);
  const history = useHistory();
  const icon =
    LEGACY_ICONS[notification.payload.icon] ?? notification.payload.icon;
  const v2Type = icon?.startsWith("v2-icons/")
    ? icon.replace("v2-icons/", "").replace(".svg", "")
    : null;
  const isUrl = !v2Type && (icon?.startsWith("http") || icon?.startsWith("/"));

  useEffect(() => {
    const interval = setInterval(() => {
      let time = notification.created_at.includes("-")
        ? moment(notification.created_at).fromNow()
        : moment(parseInt(notification.created_at)).fromNow();

      let formatedTime = time;
      formatedTime.includes("hours") &&
        (formatedTime = time.replace(" hours", "hrs"));
      formatedTime.includes("years") &&
        (formatedTime = time.replace(" years", "yrs"));
      formatedTime.includes("days") &&
        (formatedTime = time.replace(" days", "d"));

      formatedTime.includes(" minutes") &&
        (formatedTime = time.replace(" minutes", "m"));
      formatedTime.includes(" seconds") &&
        (formatedTime = time.replace(" seconds", "s"));
      formatedTime.includes("an hour ago") &&
        (formatedTime = time.replace("an hour ago", "1hr ago"));
      formatedTime.includes("a minute ago") &&
        (formatedTime = time.replace("a minute ago", "1m ago"));
      formatedTime.includes("a day ago") &&
        (formatedTime = time.replace("a day ago", "1d ago"));
      formatedTime.includes("a year ago") &&
        (formatedTime = time.replace("a year ago", "1yr ago"));
      formatedTime.includes("a year ago") &&
        (formatedTime = time.replace("a year ago", "1yr ago"));
      time.includes("a few seconds ago") &&
        (formatedTime = time.replace("a few seconds ago", "just now"));
      setTime(formatedTime);
    }, 1000);
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);
  const clickHandler = () => {
    onClick();
    const scrapedLink = notification.payload.body.match(
      /href="(https?:\/\/)*[^ "/]*([^"]*)"/
    );
    if (notification.payload.link) {
      history.push(notification.payload.link);
      if (onClose) onClose();
    } else if (scrapedLink?.[2]) {
      history.push(scrapedLink[2]); //the first capture group
      if (onClose) onClose();
    }
  };

  return (
    <CardContainer onClick={clickHandler} color={notification.payload.color}>
      <Avatar
        color={notification.payload.color}
        square={isUrl}
        size={isUrl ? "38px" : undefined}
      >
        {v2Type ? (
          <Icon type={v2Type} size={20} color="#DEDEDE" />
        ) : icon ? (
          <img
            className="selected-icon"
            src={
              isUrl
                ? icon?.startsWith("/")
                  ? `${process.env.REACT_APP_FILES_URL}${icon}`
                  : icon
                : resolveIconSrc(icon)
            }
            alt="icon"
            style={{ width: notification.payload.width ?? "100%" }}
          />
        ) : null}
      </Avatar>
      <div className="content">
        <p className="p2b name">{notification.payload.name}</p>
        <div className="p3m body">
          {parse(notification.payload.body, {
            // render anchors as styled spans so we don't get href & clickhandler double nav
            replace: domNode => {
              if (domNode.name === "a") {
                return (
                  <span className="link">{domToReact(domNode.children)}</span>
                );
              }
            }
          })}
          <>
            {notification.repeats?.length > 0 &&
              ` (${notification.repeats.length + 1})`}
          </>
        </div>
      </div>
      <div>
        <div className="time-container">
          {!notification.status && <div className="unread"></div>}
          <div className="time-sub-container">
            <p className="p3r grey time">{time}</p>
          </div>
        </div>
      </div>
    </CardContainer>
  );
};

export default NotificationCard;
